import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormAsistirComida } from '../comidas/FormAsistirComida';
import { FormAsistirActividad } from '../actividades/FormAsistirActividad';
import { getActividades, getComidas, getEventos, getOpcionesTareas, getTrabajadores } from '../../services/apis';

export const AccesoRapidoFormAsustencia = () => {
	const [opTrabajadores, setOpTrabajadores] = useState([]);
	const [succesCrearComida, setSuccesCrearComida] = useState(null);
	const [opcionesTareas, setOpcionesTareas] = useState([]);
	const [asistir, setAsistir] = useState(true);
	const [data, setData] = useState(null);
	const [loaded, setLoaded] = useState(false);
	const { id } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const esActividad = location.pathname.includes('accesorapidoactividad');
	const esLimpieza = location.pathname.includes('accesorapidolimpieza');
	const listadoDestino = esLimpieza ? '/esdeveniments' : (esActividad ? '/activitats' : '/comidas');

	const cargarEvento = useCallback(async () => {
		try {
			setLoaded(false);
			const response = esLimpieza ? await getEventos() : (esActividad ? await getActividades() : await getComidas());

			if (response?.success) {
				const evento = response.data.find((item) => item.id === parseInt(id, 10));
				setData(evento || null);
			} else {
				console.error("Error en carregar l'esdeveniment:", response?.error);
			}
		} catch (error) {
			console.error('Error en la sol·licitud:', error);
		} finally {
			setLoaded(true);
		}
	}, [esActividad, esLimpieza, id]);

	const cargarTrabajadores = async () => {
		try {
			const response = await getTrabajadores();
			const trabajadores = (response?.data || []).map((item) => ({
				label: item.nombre,
				value: item.id,
			}));
			setOpTrabajadores(trabajadores);
		} catch (error) {
			console.error('Error en carregar usuaris', error);
		}
	};

	const cargarOpcionesTareas = async () => {
		try {
			const response = await getOpcionesTareas(1);
			setOpcionesTareas(response?.data || []);
		} catch (error) {
			console.error('Error en carregar tasques', error);
		}
	};

	useEffect(() => {
		cargarEvento();
	}, [cargarEvento]);

	useEffect(() => {
		cargarTrabajadores();
		cargarOpcionesTareas();
	}, []);

	useEffect(() => {
		if (succesCrearComida) {
			cargarEvento();
		}
	}, [cargarEvento, succesCrearComida]);

	const handleClose = (open) => {
		if (!open) {
			navigate(listadoDestino);
		}
		setAsistir(open);
	};

	if (!loaded) {
		return <div>Carregant...</div>;
	}

	if (!data) {
		return <div>No s'ha trobat l'esdeveniment amb ID {id}</div>;
	}

	if (data.cerrado !== 0) {
		return <div>Aquest esdeveniment està bloquejat</div>;
	}

	return esActividad || esLimpieza ? (
		<FormAsistirActividad
			open={asistir}
			setOpen={handleClose}
			tarea={data}
			opTrabajadores={opTrabajadores}
			modo="asistir"
			setSuccesCrearComida={setSuccesCrearComida}
			permiteInvitados={!esLimpieza}
		/>
	) : (
		<FormAsistirComida
			open={asistir}
			setOpen={handleClose}
			tarea={data}
			opTrabajadores={opTrabajadores}
			modo="asistir"
			opcionesTareas={opcionesTareas}
			setSuccesCrearComida={setSuccesCrearComida}
		/>
	);
};
